import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { InterventionsDialog } from "../scripts/interventions.dialog";
import { InterventionEvent } from "../scripts/interventions.entities";
import { InterventionsLookup } from "../scripts/interventions.lookup";
import { InterventionsSummarySeries } from "./interventions-summary-entities";

var Highcharts = require('highcharts/highcharts');

export class InterventionsSummaryView {

    overallSummaryChart: any;
    siteSummaryChart: any;

    selectedGrouping: string; //site, overall
    selectedData: string; //status, reasons

    constructor() {
        this.selectedGrouping = "overall";
        this.selectedData = "status";
    }

    UpdateData(overallSeries: InterventionsSummarySeries[], siteSeries: InterventionsSummarySeries[]): void {
        overallSeries.sort((a, b) => a.name.localeCompare(b.name));
        siteSeries.sort((a, b) => {
            let aTotal = 0;
            let bTotal = 0;

            a.interventions.forEach(item => {
                aTotal += item.length;
            });

            b.interventions.forEach(item => {
                bTotal += item.length;
            });

            let result = bTotal - aTotal;

            if (result == 0) {
                result = a.name.localeCompare(b.name);
            }

            return result;
        });

        this.updateChart('interventions-bysite-summary-status-chart', siteSeries, [4, 0, 1, 5, 3, 2], "Sites");
        this.updateChart('interventions-overall-summary-status-chart', overallSeries, [4, 0, 1, 5, 3, 2], "Overall Interventions");
    }

    private updateChart(chartId: string, data: InterventionsSummarySeries[], interventionStatusIds: number[], axisLabel: string): void {

        let series: any[] = [];
        let categories: string[] = [];

        interventionStatusIds.forEach((statusId: number) => {

            let seriesData: any[] = new Array<any>(data.length).fill(0);
            for (let i = 0; i < data.length; ++i) {
                if (!categories.includes(data[i].name)) { categories.push(data[i].name); }
                if (data[i].interventions.has(statusId)) {
                    seriesData[i] = { y: data[i].interventions.get(statusId).length, interventions: data[i].interventions.get(statusId) };
                }
            }

            series.push({ name: InterventionsLookup.GetInterventionStatus(statusId), data: seriesData, colorIndex: InterventionsLookup.GetColorIndex(statusId) });

        });

        this.initializeBarChart(chartId, axisLabel, categories, series)
    }

    private initializeBarChart(chartId: string, axisLabel: string, categories: string[], data: any[]): any {

        let chart: any = Highcharts.chart(chartId, {
            chart: {
                type: 'bar',
                styledMode: true,
                height: 100 + (45 * categories.length)
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                categories: categories,
                min: 0,
                max: categories.length - 1,
                title: { text: axisLabel },
                tickInterval: 1,
                tickLength: 0,
            },
            yAxis: {
                min: 0,
                endOnTick: false,
                maxPadding: 0.2,
                reverseStacks: false,
                title: { text: 'Intervention Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    },
                    inside: false,
                    verticalAlign: 'middle',
                }
            },
            legend: {
                reversed: true,
                align: 'center',
                verticalAlign: 'top',
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    point: {
                        events: {
                            click: function () {
                                InterventionsDialog.ShowDialog(this.options.interventions);
                            }
                        }
                    },
                },
                bar: {
                    pointWidth: 25,
                    pointPadding: 0.1,
                    //groupPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            if (this.y == 0) return null;
                            else {
                                let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                else return label;
                            }
                        },
                        verticalAlign: 'middle',
                        y: 2
                    },
                },
            },
            series: data
        });

        return chart;
    }

    SetView(newView: string): void {
        
        if (!newView.startsWith("interventions-summary")) { return; }
        else if (newView != "interventions-summary") {
            if (newView.includes("overall")) { this.selectedGrouping = "overall"; }
            else if (newView.includes("bysite")) { this.selectedGrouping = "bysite"; }
        }

        if (this.selectedGrouping == "overall") { SetActiveTab("intervention-summary-tabs", "content-summary-interventions-overall-status"); }
        else if (this.selectedGrouping == "bysite") { SetActiveTab("intervention-summary-tabs", "content-summary-interventions-bysite-status"); }
    }
}